import Constants from 'Constants'

const STATIC_MAP_BASE_URL = 'https://maps.googleapis.com/maps/api/staticmap'

type StaticMapUrlArgs = {
  latitude: number
  longitude: number
  zoom: number
  width: number
  height: number
  mapType?: 'satellite' | 'roadmap' | 'hybrid' | 'terrain'
}

/**
 * Google Static Maps image URL — thumbnails render a plain <img> instead of a live map,
 * which costs a Maps JS instance plus a mapConfig fetch per mounted map.
 */
export const buildStaticMapUrl = ({ latitude, longitude, zoom, width, height, mapType = 'satellite' }: StaticMapUrlArgs): string => {
  const params = new URLSearchParams({
    center: `${latitude},${longitude}`,
    zoom: String(zoom),
    size: `${width}x${height}`,
    scale: '2',
    maptype: mapType,
    key: Constants.GOOGLE_MAPS_API_KEY ?? '',
  })
  return `${STATIC_MAP_BASE_URL}?${params.toString()}`
}

export default buildStaticMapUrl
